import { Injectable } from '@angular/core';
import { ofType, createEffect, Actions } from '@ngrx/effects';

import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { NewsService } from '@cpd-app/core-module/services';

import {
  getNews,
  getNewsSuccess,
  getNewsTypesSuccess,
  getNewsTypesFailure,
  reactOnNews,
  reactOnNewsSuccess,
  reactOnNewsFailure
} from './news.actions';

@Injectable()
export class NewsEffects {
  public getNews$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getNews),
      switchMap(() => {
        return this.newsService.getNews().pipe(
          mergeMap((response) => [
            getNewsSuccess({
              news: response.news
            }),
            getNewsTypesSuccess({
              newsTypes: response.newsTypes
            })
          ]),
          catchError((error) => of(getNewsTypesFailure({ error })))
        );
      })
    );
  });

  public reactOnNews$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(reactOnNews),
      switchMap(({ input }) => {
        return this.newsService.reactOnNews(input).pipe(
          map((newsItem) => {
            return reactOnNewsSuccess({ newsItem });
          }),
          catchError((error) => of(reactOnNewsFailure({ error })))
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private newsService: NewsService
  ) {}
}
